import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';

export type LossContractFormType = {
  lossReason: FormControl<string>;
  lossComment: FormControl<string>;
};

export class LossContractForm extends FormGroup<LossContractFormType> {
  get lossReasonErrorMessage(): ErrorMessage {
    return FormHelper.getEmptyErrorMessage(this.controls.lossReason, 'Le motif est requis.');
  }

  constructor() {
    super({
      lossReason: new FormControl<string>(null, Validators.required),
      lossComment: new FormControl<string>(null)
    });
  }
}
